<template>
  <div>
    <div>
      <!--<van-nav-bar :fixed="true" :title="busInfo.linename" left-arrow @click-left="onClickLeft"/>-->
      <van-nav-bar :fixed="true" :title="busInfo.linename"/>
    </div>
    <div class="content">
      <div class="line-info-wrap" @click="goLineDetail">
        <div class="line-info">
          <div>
            <div>
              <van-icon name="location" color="#0CC893"/>
              <span style="font-size: 16px">{{ busInfo.startname }}</span>
            </div>
            <div style="text-align: center;font-size: 14px">{{ busInfo.starttime }}</div>
          </div>
          <div>
            <div style="text-align: center;">
              <img src="../../static/images/right.png" width="51px" height="30px">
            </div>
            <div>
              <span style="font-size: 12px;color: red;">点击查看站点</span>
            </div>
          </div>
          <div>
            <div>
              <van-icon name="location" color="#FF0200"/>
              <span style="font-size: 16px">{{ busInfo.endname }}</span></div>
            <div style="text-align: center;font-size: 14px">{{ busInfo.endtime }}</div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 10px;">
        <!--<van-cell center title="日票">-->
        <!--<template #right-icon>-->
        <!--<van-switch @change="handleSwitchChange" v-model="checked"size="24" />-->
        <!--</template>-->
        <!--</van-cell>-->
        <van-cell center title="购票方式">
          <template #right-icon>
            <van-radio-group v-model="radio" direction="horizontal" @change="handleSwitchChangeM">
              <van-radio name="1">日票</van-radio>
              <van-radio :disabled="monthly_status" name="2">
                {{ next_month }}月票
                <span style="font-size: 12px;" v-if="(typeof surplus == 'number')&&surplus<=5">({{ surplus }}张)</span>
                <span style="font-size: 12px;" v-if="msoldstart===0">(待售)</span>
              </van-radio>
            </van-radio-group>
            <!--<van-switch :disabled="monthly_status" @click="handleSwitchClickM" @change="handleSwitchChangeM" v-model="checked2" size="24" />-->
          </template>
        </van-cell>
      </div>
      <div style=" background-color: white;">
        <div class="date-title">
          <van-row>
            <van-col span="6" style="text-align: center; height: 46px; overflow: hidden; display: block;">
              <van-button icon="arrow-left" type="primary" @click="preMonth" plain
                          color="#333" style="border:none;"/>
            </van-col>
            <van-col span="12" style="text-align: center">
              <span>{{ dateTitle }}</span>
            </van-col>
            <van-col span="6" style="text-align: center; height: 46px; overflow: hidden; display: block;">
              <van-button icon="arrow" type="primary" @click="nextMonth" plain color="#333"
                          style="border:none;"/>
            </van-col>
          </van-row>
        </div>

        <div class="data-week-title">
          <span v-for="item in week" :key="item">{{ item }}</span>
        </div>
        <div v-for="val in ticketData" class="date-li">
          <div v-for="(item,index) in val" :class="getItemClass(item)" ref="item" @click="addBuyTicket(item)">
            <div>{{ item ? item.date : '&nbsp;&nbsp;&nbsp;&nbsp;' }}</div>
            <div :class="generateClassName(item)" style="font-size: 12px;">
              {{ item ? item.statename : '&nbsp;&nbsp;&nbsp;&nbsp;' }}
            </div>
          </div>
        </div>
      </div>
      <div class="van-cell--borderless"></div>
      <div class="tick-wrap" style="height: auto;">
        <van-cell center>
          <template #right-icon>
            <van-radio-group v-model="option" direction="" @change="changeOption">
              <van-radio style="height: 32px;" name="0">全程票({{busInfo.ticketPrice}}元)</van-radio>
              <van-radio v-for="option in ticketOptions" style="height: 32px;" :name="option.id">
                {{option.name}}（{{option.price}}元）
              </van-radio>
            </van-radio-group>
          </template>
        </van-cell>
      </div>
      <div class="tick-wrap">
        <span style="color: #202020;font-size: 16px;">张数</span>
        <span>
                    <span style="color: #0CC893;font-size: 22px;">{{ num }}</span>
                    <span style="color: #202020;font-size: 16px;">张</span>
                </span>
      </div>
      <div class="tick-wrap">
        <span style="color: #202020;font-size: 16px;">票价</span>
        <span v-if="radio == '1'" style="color: #FF0200;font-size: 22px;">￥{{ amount }} </span>
        <span v-else style="color: #FF0200;font-size: 22px">
                    <span>￥{{ money }} <span style="font-size: 12px;">(月票)</span></span>
                    <span
                        style="color: #999;font-size: 12px;text-decoration: line-through;padding-left: 10px;">￥{{ amount }}(原价)</span>
                </span>

      </div>

      <div class="btn-wrap">
        <van-button @click="buy" style="width: 100%;height:44px" color="#0CC893" type="default">
          确认购票
        </van-button>
      </div>
      <div style="padding: 10px">
        <div>
          <van-icon name="warning" color="#F55456"/>
          注意:
        </div>
        <div class="notice">
          <div>
            1、发车前1小时内不能进行退票处理
          </div>
          <div>
            2、已发车线路不能进行退票处理
          </div>
          <div>
            3、请提前5分钟到乘车站点等车
          </div>
          <div>
            4、每人每次能购买一张车票
          </div>
          <div>
            5、如购买多张，需要多次购买
          </div>
          <div>
            6、购买月票用户可以享受月票的价格优惠
          </div>
          <div>
            7、购买月票，由于不同线路退票规则不同，请具体参考各线路月票公告
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <van-tabbar v-model="active" active-color="rgb(12, 200, 147)" inactive-color="#FFFFFF"
                  style="background:#5083ED ">
        <van-tabbar-item :icon="car" to="/busIndex">预定巴士</van-tabbar-item>
        <van-tabbar-item :icon="scan" to="/ticketList">乘车验票</van-tabbar-item>
        <van-tabbar-item :icon="user" to="/user">个人中心</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import {NavBar, Button, Icon, Tabbar, TabbarItem, Row, Col, Switch, Form, Cell, Divider, RadioGroup, Radio} from 'vant';
import Kalendar from 'kalendar';
import request from '../../utils/request';
import moment from 'moment';

import car from './../../static/images/busTrip/car.png'
import scan from './../../static/images/busTrip/scan.png'
import user from './../../static/images/busTrip/user.png'

export default {
  components: {
    [Row.name]: Row,
    [Cell.name]: Cell,
    [Col.name]: Col,
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Switch.name]: Switch,
    [Form.name]: Form,
    [Divider.name]: Divider,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  data() {
    return {
      startnum: 0,//日期从第几位开始
      user: user,
      car: car,
      scan: scan,
      active: "",
      num: 0,//购票张数
      currentOption: 0, //当前所选规格
      ticketOptions: [], //规格信息
      price: 0, //车票单价
      amount: 0,
      money: 0,
      currentDate: moment(),
      chooseDate: [],
      busid: '',
      lineid: '',
      checked: true,
      checked2: false,
      monthly_status: false,
      next_month: '',
      surplus: '',
      msoldstart: '',
      daysoldstart: '',
      daysolddate: '',
      busInfo: {
        busnumber: "",
        endid: "",
        endname: "",
        endtime: "",
        lineid: "",
        linename: "",
        startid: "",
        startname: "",
        starttime: "",
        ticketPrice: "",
        ticketOption: ""
      },
      ticketData: {},
      data: [],
      dateTitle: moment().format('YYYY年MM月'),
      week: ["日", "一", "二", "三", "四", "五", "六"],
      radio: '1',
      option: "0",
    }
  },
  watch: {
    // 'checked': function (n) {
    //     if(n){
    //         this.checked2 = false
    //     }else{
    //         if(this.checked2){
    //             this.checked = true
    //         }
    //     }
    // },
    // 'checked2': function (n) {
    //     console.log(n)
    //     if(n){
    //         this.checked = false
    //     }
    // }
  },
  methods: {
    goLineDetail() {
      this.$router.push({path: "/busDetail", query: {busid: this.busid}})
    },
    handleSwitchChange(c) {
      if (c) {
        this.checked2 = false;
        // this.initData()
      } else {
        if (!this.checked2) {
          this.checked = true
        }
      }
    },
    handleSwitchClickM() {
      if (this.monthly_status) {
        this.$toast.fail("当前月份不可购买。");
      }
    },
    handleSwitchChangeM(flag) {
      console.log(flag)
      if (flag == '2') {
        if (this.currentDate.format('YYYY-MM') == moment(this.next_month).format('YYYY-MM')) {
          this.handleMapDate();
        } else {
          this.num = 0;
          this.ticketData = {};
          this.chooseDate = [];
          this.currentDate = moment(this.next_month, 'YYYY-MM');
          this.dateTitle = this.currentDate.format('YYYY年MM月');
          let elArr = this.$refs.item;
          for (let i = 0; i < elArr.length; i++) {
            let el = elArr[i];
            el.classList.remove('choose');
          }
          this.initData(1);
        }
        // this.initData(this.next_month) ;
      }
      else {
        if (this.daysoldstart==0){
          this.num=0;
          this.amount=0;
          this.chooseDate=[];
          let elArr = this.$refs.item;
          for (let i = 0; i < elArr.length; i++) {
            let el = elArr[i];
            el.classList.remove('choose');
          }
        }
      }
      // if(c){
      //     this.checked = false ;
      //     // this.initData()
      //     this.handleMapDate() ;
      // }else{
      //     if(!this.checked){
      //         this.checked2 = true
      //     }
      // }
    },
    handleMapDate() {
      // alert()
      this.ticketData.forEach((_item, _index) => {
        _item.forEach((item, index) => {
          if (item && (item.state === 1 || item.state === 2)) {
            let index2 = this.chooseDate.indexOf(item.dateText);
            if (index2 === -1) {
              this.chooseDate.push(item.dateText);
              let el = this.$refs.item[item.date - 1 + this.startnum];
              el.classList.add('choose');
              this.num += 1;
            }
          }
        });

      });
      this.amount = this.num * this.price;
      // this.amount = this.num * this.busInfo.ticketPrice;
      // console.log(this.ticketData)

    },
    nextMonth() {
      this.checked = true;
      this.checked2 = false;
      this.radio = '1';
      this.num = 0;
      this.ticketData = {};
      this.chooseDate = [];
      this.currentDate = moment(this.currentDate, 'YYYY-MM').add(1, 'months');
      this.dateTitle = this.currentDate.format('YYYY年MM月');
      let elArr = this.$refs.item;
      for (let i = 0; i < elArr.length; i++) {
        let el = elArr[i];
        el.classList.remove('choose');
      }
      this.initData();
    },
    preMonth() {
      this.checked = true;
      this.checked2 = false;
      this.radio = '1';
      this.num = 0;
      this.ticketData = {};
      this.chooseDate = [];
      this.currentDate = moment(this.currentDate, 'YYYY-MM').subtract(1, 'months');
      this.dateTitle = this.currentDate.format('YYYY年MM月');

      let elArr = this.$refs.item;
      for (let i = 0; i < elArr.length; i++) {
        let el = elArr[i];
        el.classList.remove('choose');
      }

      this.initData();

    },
    getItemClass(item) {
      if (item) {
        switch (item.state) {
          case 2:
            return 'date-item date-item-bought';
          case  5:
            return 'date-item date-item-sellOut';
          default:
            return 'date-item date-item-default';
        }
      }
      return 'date-item date-item-default';
    },
    generateClassName(item) {
      if (item) {
        switch (item.state) {
          case 0:
            return '';
          case 1:
            return 'haveTicket';
          case 2:
            return 'bought';
          case 3:
            return 'rest';
          case 4:
            return 'saleStop';
          case 5:
            return 'sellOut';
        }
      }
    },
    onClickLeft() {
      this.$router.back(-1);
    },
    addBuyTicket(item) {
      // console.log(item) ;
      if (this.daysoldstart === 0) {
        this.$toast.fail("日票暂未发售，请于" + this.daysolddate + '后购买。');
        return false;
      }
      if (this.radio == '2') {
        // this.$toast('月票不能单个取消') ;
        this.$dialog.confirm({
          title: '提示',
          message: '月票不能单个取消，是否切换购买方式为日票并取消当日车票？'
        }).then(() => {
          this.radio = '1';
          if (item && (item.state === 1 || item.state === 2)) {
            let index2 = this.chooseDate.indexOf(item.dateText);
            if (index2 === -1) {
              this.chooseDate.push(item.dateText);
              let el = this.$refs.item[item.date - 1 + this.startnum];
              el.classList.add('choose');
              // el.style.backgroundColor = '#0CC893';
              // el.style.color = '#fff';
              this.num += 1;
              // console.log(1)
            } else {
              this.chooseDate.splice(index2, 1);
              let el = this.$refs.item[item.date - 1 + this.startnum];
              el.classList.remove('choose');
              //  if (item.state === 2) {
              //      el.style.backgroundColor = '#5083ED';
              //      el.style.color = '#fff';
              //  } else {
              //      el.style.backgroundColor = '#fff';
              //      el.style.color = '#202020';
              // }
              this.num -= 1;
            }
            this.amount = this.num * this.price;
            // this.amount = this.num * this.busInfo.ticketPrice;
          }
        }).catch(res => {

        });
      } else {
        if (item && (item.state === 1 || item.state === 2)) {
          let index2 = this.chooseDate.indexOf(item.dateText);
          if (index2 === -1) {
            this.chooseDate.push(item.dateText);
            let el = this.$refs.item[item.date - 1 + this.startnum];
            el.classList.add('choose');
            // el.style.backgroundColor = '#0CC893';
            // el.style.color = '#fff';
            this.num += 1;
            // console.log(1)
          } else {
            this.chooseDate.splice(index2, 1);
            let el = this.$refs.item[item.date - 1 + this.startnum];
            el.classList.remove('choose');
            //  if (item.state === 2) {
            //      el.style.backgroundColor = '#5083ED';
            //      el.style.color = '#fff';
            //  } else {
            //      el.style.backgroundColor = '#fff';
            //      el.style.color = '#202020';
            // }
            this.num -= 1;
          }
          this.amount = this.num * this.price;
          // this.amount = this.num * this.busInfo.ticketPrice;
        }
      }


    },
    buy() {
      if (this.num === 0) {
        this.$toast.fail("请先选择车票日期");
        return;
      }
      this.$router.push({
        path: '/ticketPayment',
        query: {
          'num': this.num,
          'amount': this.radio == '2' ? (this.money) : this.amount,
          'busid': this.busid,
          'lineid': this.lineid,
          'dateStr': this.chooseDate,
          'ticketOptionId': this.currentOption,
          'ismonth': this.radio == '2' ? 1 : 0
        }
      });
    },
    queryBus() {
      request.sendPost({
        url: '/bus/selectLineInfo/' + this.busid,
        params: {}
      }).then((res) => {
        if (res.data.code === 0) {
          this.busInfo = res.data.data;
          this.price = res.data.data.ticketPrice;
          this.ticketOptions = res.data.data.ticketOption;
        }
      })
    },
    changeOption(flag) {
      var that = this;
      console.log("规格：" +flag);
      if (flag === "0"){
        this.price = this.busInfo.ticketPrice;
        this.currentOption=0;
      }else {

        this.ticketOptions.forEach(function (option){
          console.log(option);
          console.log(flag+":"+option.id);
          if(option.id == flag){
            that.price = option.price;
            that.currentOption = option.id;
          }
        });
      }
      this.amount = this.num * this.price;
    },
    initData(next_month) {
      let loading = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...'
      });
      let currentDate = this.currentDate.format('YYYY-MM');

      request.sendPost({
        url: '/bus/ticketlist',
        params: {
          month: currentDate,
          busid: this.busid,
          lineid: this.lineid
        }
      }).then((res) => {
        if (res.data.code === 0) {
          console.log(res.data.rows)
          // res.data.rows[4].state = 2
          this.data = res.data.rows;
          if (res.data.data) {
            this.monthly_status = res.data.data.monthenable == 1 ? false : true;
            this.money = res.data.data.mticketprice;
            this.next_month = res.data.data.nextmonth;
            this.surplus = res.data.data.residuenum;
            this.msoldstart = res.data.data.msoldstart;
            this.daysoldstart = res.data.data.daysoldstart;
            this.daysolddate = res.data.data.daysolddate;
          }
        } else {
          this.$toast.fail(res.data.msg);
        }
        let date = new Date(this.currentDate);
        this.initKalendar(date, next_month, loading);
        if (!next_month) {
          loading.clear();
        }

      })
          .catch(() => {
            loading.clear();
          })
    },
    initKalendar(date, flag, loading) {
      let arr = {};
      if (this.data && this.data.length > 0) {
        console.log(this.data)
        for (let i = 0, len = this.data.length; i < len; i++) {
          let k = this.data[i].date;
          let v1 = this.data[i].statename;
          let v2 = this.data[i].state;
          arr[k] = {'statename': v1, 'state': v2};
        }
      }
      let continuous = false;
      let mount = arr;
      // console.log(arr)
      // if(arr['2020-07-01']){
      //     arr['2020-07-01'].state = 2 ;
      // }
      let unifiedMount = {
        // state: '售票'
      };
      this.ticketData = Kalendar.monthly({
        date: date,
        mount: mount,
        unifiedMount: unifiedMount,
        continuous: continuous
      });
      let num = 0;
      for (let i = 0; i < this.ticketData[0].length; i++) {
        if (!this.ticketData[0][i]) {
          num += 1;
        }
      }
      this.startnum = num;
      let currentMonth = moment(date).format("MM");
      for (let index in this.chooseDate) {
        let date1 = this.chooseDate[index];
        let month = moment(date1).format("MM");
        let day = parseInt(moment(date1).format("DD"));
        if (month === currentMonth) {
          let el = this.$refs.item[day - 1 + this.startnum];
          el.classList.add('choose');
        }
      }
      if (flag) {
        setTimeout(() => {
          this.handleMapDate();
          loading.clear();
        }, 1000)
      }

    }
  },
  created() {
    this.busid = this.$route.query.busid;
    this.lineid = this.$route.query.lineid;
    this.initData();
    this.queryBus();
  }
}
</script>

<style scoped>
/*-----------日历模块样式start--------------*/
/*!!!!不要换class位置 ,会对样式产生影响*/
.choose {
  background-color: #0CC893 !important;
  color: #fff !important;
}

.saleStop {
  color: #0CC893;
}

.haveTicket {
  /*color: #202020;*/
}

.rest {
  color: #FF0200;
}

.sellOut {
  color: #5E5E5E;
}

.bought {
  color: #fff;
}

.date-item-sellOut {
  background-color: #CFCFCF;
  color: #5E5E5E;
}

.date-item-default {
  background-color: white;
  color: #202020;
}

.date-item-bought {
  background-color: #5083ED;
  color: white;
}

.date-item {
  border-right: 1px solid #ECECEC;
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

/*-----------日历模块样式end--------------*/
.tick-wrap {
  height: 48px;
  background-color: white;
  border-bottom: 1px solid #ECECEC;
  font-weight: bold;
  padding: 0 33px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn-wrap {
  background-color: white;
  padding: 14px 15px;
}

.date-li {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #ECECEC;
}


.date-title {
  height: 48px;
  text-align: center;
  font-size: 18px;
  line-height: 48px;
  font-weight: bold;
  color: #202020;
  border-bottom: 1px #ECECEC solid;
}

.data-week-title {
  height: 31px;
  border-bottom: 1px #ECECEC solid;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 12px;
  color: #5E5E5E;
}

.data-week-title span:first-child {
  color: #0CC893
}

.data-week-title span:last-child {
  color: #0CC893
}

/deep/ .van-nav-bar .van-icon {
  color: #5E5E5E
}

.content {
  margin-top: 46px;
  margin-bottom: 50px;
}

.line-info-wrap {
  background-color: #F6F6F6;
  padding: 12px 13px;
  height: 90px;
}

.line-info {
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: space-around;
  background-color: white;
  font-weight: bold;
  color: #202020;
}

.footer {
  width: 100%;
}

</style>
